import {
  InvestmentChartConfig,
  InvestmentChartCatergory,
} from './investment-calculator.model';

const grid = {
  left: 60,
  right: 10,
  top: 10,
  bottom: 20,
};

export const barChartConfig = {
  legend: {
    show: false,
    selectedMode: false,
  },
  tooltip: {
    trigger: 'axis', // or 'item'
    axisPointer: {
      type: 'shadow', // or 'shadow'
    },
  },
  grid,
  color: [], // Set this in code
  yAxis: {
    type: 'value',
  },
  xAxis: {
    type: 'category',
    data: [], // Set this in code
  },
  series: [], // Set this in code
};

export const investmentChartConfig: InvestmentChartConfig[] = [
  {
    category: InvestmentChartCatergory.INVESTMENT,
    label: 'Investment',
    color: '#121c30',
    borderRadius: [0, 0, 6, 6],
  },
  {
    category: InvestmentChartCatergory.VALUE_APPRECIATION,
    label: 'Value appreciation',
    color: '#ffd147',
    borderRadius: [0, 0, 0, 0],
  },
  {
    category: InvestmentChartCatergory.RENTAL_INCOME,
    label: 'Total rental income',
    color: '#60a5fa',
    borderRadius: [6, 6, 0, 0],
  },
];
